import { response } from './response';
import { sleep } from './sleep';
import { createTopMock } from '../top';
import { MockApi } from './types';
import type { createTopApi } from '@/src/api/top';

export default {
  async getTop() {
    await sleep();
    return new Promise((resolve) => {
      return resolve(response(createTopMock()));
    });
  },
} as MockApi<ReturnType<typeof createTopApi>>;
